import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-challenge-v003',
  templateUrl: './challenge-v003.component.html',
  styleUrls: ['./challenge-v003.component.scss']
})
export class ChallengeV003Component implements OnInit {

  @Input() timer;

  constructor() { }

  ngOnInit(): void {
  }

}
